import permission from './permission'
import store from '@/store'
import helper from '@/unit/helper'

const install = function(Vue) {
  Vue.directive('has', permission)
  
  // 添加 $has 方法到 Vue 原型上
  Vue.prototype.$has = function(permission) {
    const permissionList = store.getters && store.getters.permissionList
    if (!permissionList || !Array.isArray(permissionList)) {
      return false
    }
    return helper.arrContains(permissionList, permission)
  }
}

if (window.Vue) {
  window['has'] = permission
  Vue.use(install); // eslint-disable-line
}

permission.install = install
export default permission